import { useState } from 'react';
import { SubmittedInvoiceCard } from './SubmittedInvoiceCard';
import type { AgreementInvoice } from '../types/agreements.types';

interface Props {
    invoices: AgreementInvoice[];
    dealerNames: Map<string, string>;
    canReverse?: (invoice: AgreementInvoice) => boolean;
    onReverse?: (invoice: AgreementInvoice) => void;
}

/** One invoice open at a time, opening on the most recent (the server sends them newest first). */
export function SubmittedInvoiceList({ invoices, dealerNames, canReverse, onReverse }: Props) {
    const [expandedId, setExpandedId] = useState<string | null>(() => invoices[0]?.id ?? null);

    return (
        <ul className="space-y-3">
            {invoices.map((invoice) => (
                <SubmittedInvoiceCard
                    key={invoice.id}
                    invoice={invoice}
                    dealerName={dealerNames.get(invoice.invoicingDealerId) ?? invoice.invoicingDealerId}
                    expanded={expandedId === invoice.id}
                    onReverse={onReverse && canReverse?.(invoice) ? () => onReverse(invoice) : undefined}
                    onToggle={() => setExpandedId((current) => (current === invoice.id ? null : invoice.id))}
                />
            ))}
        </ul>
    );
}
